module.exports = __webpack_public_path__ + "static/media/black-logo.0939b62f.png";